import SignaturePad from 'signature_pad';

export type SignaturePoint = {
  x: number;
  y: number;
  time: number;
  color: string;
};

export type SignaturePointGroup = SignaturePoint[];

/**
 * Redraw signature_pad stroke data (CSS-pixel coordinates relative to the
 * on-screen canvas) onto a bitmap whose size matches the ticket face.
 *
 * react-signature-canvas records pointer positions via getBoundingClientRect,
 * which is CSS pixels. The live canvas bitmap may be larger (devicePixelRatio)
 * without a matching ctx.scale — that produces a PNG with ink only in the
 * top-left. Replaying points onto a CSS-sized canvas maps the scribble onto
 * the ticket 1:1.
 */
export function renderSignaturePointsToCanvas(
  pointGroups: SignaturePointGroup[],
  cssWidth: number,
  cssHeight: number,
): HTMLCanvasElement {
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(cssWidth));
  canvas.height = Math.max(1, Math.round(cssHeight));

  const pad = new SignaturePad(canvas, {
    penColor: 'black',
    backgroundColor: 'rgba(0,0,0,0)',
    minWidth: 0.5,
    maxWidth: 2.5,
  });
  pad.fromData(pointGroups as Parameters<SignaturePad['fromData']>[0]);
  pad.off();
  return canvas;
}

export function canvasToPngBlob(canvas: HTMLCanvasElement): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error('Failed to encode signature PNG'));
        return;
      }
      resolve(blob);
    }, 'image/png');
  });
}
